/**
 * @fileoverview Space theme - match space and celestial emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Space theme with stars, planets, and celestial objects.
 */
export class SpaceTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'space',
            'Space',
            allLabels.space,
            { numPairs: 3, isPremium: true, hasMovement: false, ...options }
        );
    }
}
